import VendorFormModal from "./VendorFormModal";
import {useMemo, useState} from "react";
import {useDispatch} from "react-redux";

import {updateVendor} from "../../redux/slices/vendor";
import {nanoid} from "@reduxjs/toolkit";
import {toast} from "react-toastify";

export default function VendorEditionModal({show, onClose, vendor}) {

    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [dataLock]=useState(vendor)

    const format = useMemo(()=>{
        return {...dataLock,Stores:dataLock.Stores.map(store=>({...store,key:nanoid()}))}
    },[dataLock])

    const handleClose = ()=>{
        onClose && onClose()
    }

    const handleSubmit = (data) => {

        setIsLoading(true)

        dispatch(updateVendor({
            data: {id:vendor.id,...data}, onResolve: (type) => {
                setIsLoading(false)

                if(type==='failed')
                    toast.error('Error! check internet connection')

                handleClose()
            }
        }))

    }

    return (
        <VendorFormModal
            title='Modification des donnees du vendor'
            show={show}
            isLoading={isLoading}
            onClose={onClose}
            onSubmit={handleSubmit}
            vendor={format}
        />
    )

}